import { CommonModule } from '@angular/common';
import { Component, ElementRef, EventEmitter, Input, NgModule, OnChanges, Output, SimpleChanges } from '@angular/core';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatTooltipModule } from '@angular/material/tooltip';
import { ListLoadingIndicatorComponent, LoadingAttributeComponent } from '@shared/ui';
import { TranslateModule } from '@ngx-translate/core';

export interface DeviceTypeListItem {
  id: string;
  name: string;
  version: string;
  numDevices?: number;
}

export enum DeviceTypeColumn {
  NAME = 'name',
  VERSION = 'version',
  NUM_DEVICES = 'numDevices',
}

@Component({
    selector: 'ts-device-types-list',
    templateUrl: './device-types-list.component.html',
    styleUrls: ['./device-types-list.component.scss'],
    standalone: false
})
export class DeviceTypesListComponent implements OnChanges {
  @Input() items: DeviceTypeListItem[] = [];
  @Input() loading = false;
  @Input() noDeviceTypes = false;
  @Input() columns: DeviceTypeColumn[] = [
    DeviceTypeColumn.NAME,
    DeviceTypeColumn.VERSION,
    DeviceTypeColumn.NUM_DEVICES,
  ];

  // Store the container height when loading starts to prevent layout jumps
  public containerHeight: number | null = null;

  constructor(private elementRef: ElementRef) {}

  ngOnChanges(changes: SimpleChanges): void {
    // When loading starts, capture the current height
    if (changes['loading'] && changes['loading'].currentValue === true) {
      const element = this.elementRef.nativeElement as HTMLElement;
      if (element && element.offsetHeight > 0) {
        this.containerHeight = element.offsetHeight;
      }
    }
    // When loading ends, clear the fixed height
    if (changes['loading'] && changes['loading'].currentValue === false) {
      this.containerHeight = null;
    }
  }

  get visibleColumns(): string[] {
    return this.columns.map((col) => col.valueOf());
  }
}

@NgModule({
  declarations: [DeviceTypesListComponent],
  exports: [DeviceTypesListComponent],
  imports: [
    CommonModule,
    TranslateModule,
    MatTableModule,
    MatSortModule,
    MatIconModule,
    MatButtonModule,
    MatTooltipModule,
    LoadingAttributeComponent,
    ListLoadingIndicatorComponent,
  ],
})
export class DeviceTypesListComponentModule {}
